import React, { useEffect, useState, useRef } from 'react';
import HelpSidebar from '../components/HelpSidebar';
import HelpSearch from '../components/HelpSearch';
import { helpSections, searchableContent } from '../data/helpContent';
import '../styles/Help.css';

function Help() {
  const [activeSection, setActiveSection] = useState('introduction');
  const contentRef = useRef<HTMLDivElement>(null);
  const observerRef = useRef<IntersectionObserver | null>(null);

  // Set up Intersection Observer for auto-highlighting active section
  useEffect(() => {
    const observerOptions = {
      root: null,
      rootMargin: '-100px 0px -80% 0px',
      threshold: 0,
    };

    observerRef.current = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          setActiveSection(entry.target.id);
        }
      });
    }, observerOptions);

    // Observe all section elements
    const sections = document.querySelectorAll('.help-section');
    sections.forEach((section) => {
      if (observerRef.current) {
        observerRef.current.observe(section);
      }
    });

    return () => {
      if (observerRef.current) {
        observerRef.current.disconnect();
      }
    };
  }, []);

  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      const offsetTop = element.offsetTop - 100; // Account for fixed nav
      window.scrollTo({
        top: offsetTop,
        behavior: 'smooth',
      });
      setActiveSection(sectionId);
    }
  };

  const sidebarSections = helpSections.map(section => ({
    id: section.id,
    title: section.title,
  }));

  return (
    <div className="help-page">
      <HelpSidebar
        sections={sidebarSections}
        activeSection={activeSection}
        onSectionClick={scrollToSection}
      />
      
      <div className="help-content-wrapper">
        <div className="help-content" ref={contentRef}>
          <div className="help-header">
            <h1 className="help-page-title">Beep User Guide</h1>
            <p className="help-page-subtitle">
              Complete documentation for using Beep, the macOS Android device management tool
            </p>
          </div>

          <HelpSearch
            sections={searchableContent}
            onResultClick={scrollToSection}
          />

          {helpSections.map((section) => (
            <section key={section.id} id={section.id} className="help-section">
              <h2 className="help-section-title">{section.title}</h2>
              <div className="help-section-content">
                {section.content}
              </div>
            </section>
          ))}
        </div>
      </div>
    </div>
  );
}

export default Help;
